import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8001/api";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});
// Extract CSRF token from cookies
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Auto-inject CSRF token for state-changing requests
let csrfBootstrapPromise = null;

async function ensureCsrfCookie() {
  const existing = getCookie("csrftoken");
  if (existing) return existing;

  if (!csrfBootstrapPromise) {
    csrfBootstrapPromise = api
      .get("/csrf/")
      .catch(() => null)
      .finally(() => {
        csrfBootstrapPromise = null;
      });
  }

  await csrfBootstrapPromise;
  return getCookie("csrftoken");
}

api.interceptors.request.use(async (config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const csrfToken = (await ensureCsrfCookie()) || getCookie("csrftoken");
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }
  }
  return config;
});

export const getProducts = (params = {}) => api.get("/products/", { params });
export const getProduct = (id) => api.get(`/products/${id}/`);
export const getStats = () => api.get("/products/stats/");
export const getDashboard = () => api.get("/products/dashboard/");
export const enrichProduct = (id) => api.post(`/products/${id}/enrich/`);
export const enrichAll = (limit = 100, force = false, scrape = false) =>
  api.post("/products/enrich_all/", { limit, force, scrape });

export default api;
